<template>
  <section class="content" style="position: relative;">
    <div :class="addButtonClass" class="common_save_btn">
      <router-link :to="{ name: 'UserCreate',params: {_id: '0' } }">
            <button class=" btn gradientbt">+ Add User</button>
          </router-link>
        </div>
    <div>
      <div class="box-body user_wrp_res">
        <!-- <div :class="addButtonClass" v-permission.if="['createUser']">
          <router-link :to="{ name: 'UserCreate',params: {_id: '0' } }">
            <button class=" btn gradientbt">Add User</button>
          </router-link> -->
        <!-- </div> -->

        <v-server-table
          ref="userTable"
          url
          :limit="5"
          :columns="columns"
          :options="options"
          @loaded="onLoaded"
        >
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>
          <template slot="action" slot-scope="props">
            <div>
              <a
                class="fa fa-edit"
                role="button"
                v-on:click.stop="action(props.row)"
              ></a>
            </div>
          </template>

          <template slot="action" slot-scope="props">
            <div class="active_wrp">
              <a
                class="fa fa-edit"
                role="button"
                v-on:click.stop="action(props.row)"
              ></a>
              <div class="py-2 text-center row">
                <label class="toggle">
                  <input
                    class="toggle-checkbox"
                    type="checkbox"
                    :checked="props.row.isActive"
                    @click.prevent="(e) => activateUserModal(props.row)"
                  />
                  <span class="slider"></span>
                  <!-- <span
                    class="labels"
                    data-on="Active"
                    data-off="Deactivate"
                  ></span> -->
                </label>
              </div>
            </div>
          </template>

          <!-- <template>
            <div class="form-group col-md-2">
              <select
                @change="applyFilter(custom_filter_select)"
                class="form-control"
              >
                <option v-for="value in custom_filter_options" :key="value">{{value}}</option>
              </select>
            </div>
            <button class="btn btn-default inline" @click="clearFilter('')">clear</button>
          </template> -->
        </v-server-table>
      </div>
    </div>
  </section>
</template>

<script>
import { authService } from "../../../services";
import { eventBus } from "../../../services";
import { USER_ROLES } from "../../../config";
import { ServerTable, Event } from "vue-tables-2";
import { mapState } from "vuex";

import store from "../../../store";
import swal from "sweetalert2";
import moment from "moment";

export default {
  name: "Users",
  data() {
    return {
      loading: null,
      USER_ROLES: USER_ROLES,
      userTable: null,
      columns: ["firstName", "lastName", "roleName","mobile","email", "action"], //@rohit removed 'edit'
      // custom_filter_options: ['Active', 'Deactivate','status'],
      // custom_filter_select: '',
      options: {
        highlightMatches: true,
        headings: {
          
          firstName: " First Name",
          lastName: " Last Name",
          roleName: "Role Type",
          mobile :"Contact",
          email:"Email",
          action: "Action",
        },
         sortable: [          
          'firstName',
          'lastName',
          'roleName',
          'mobile',
          'email',
        ],
        templates: {
          lastName(row, query) {
              if (!query.lastName ) {
                  return ('NA');
              } else {
                  return (query.lastName);
              }
          },
        },
        perPage: 10,
        requestFunction: (request) => {
         
          const params = {};
          params.page = request.page;
          params.limit = request.limit;
          params.sortBy= 'createdAt'
          params.sortOrder= 'des' 
          if (request.orderBy) {
            if(request.orderBy === 'roleName'){
              params.sortBy = 'role.name';
            } else{
              params.sortBy = request.orderBy;
            }
            if(request.ascending == 1){
              params.sortOrder = "asc";
            }else{
              params.sortOrder = "des";
            }
          }

          if (request.query != "") {
            // if(request.query.length < 3) return;
            params.searchString = request.query.trim();
          }
          this.loading = true;
          
          return this.$userRepository
            .listOfUsersWithRoleInfo(params)
            .catch((error) => {
              console.error("Users.requestFunction-error:", error);
            });
        },
        responseAdapter: (response) => {
          this.loading = false;
          var dataResp = [];
          let count;
          response.data.response.forEach((element) => {
            var userData = element;
            userData["roleName"] = element.role.name;
            dataResp.push(userData);
          });

          if(dataResp.length === 0){
            count = 0
          }

          return {
            data: dataResp,
            count: response.data.total || count,
          };
        },
        // customFilters: [{
        //     name: 'custom_filter',
        //     callback: function (row, query) {
        //         //	return row.role[0] == query;
        //     },
        // }, ],
        // uniqueKey: '_id',
      },
    };
  },
  computed: {
    addButtonClass() {
      if (this.userTable) {
        return this.userTable.count > this.userTable.limit ||
          this.userTable.limit > 10
          ? "shift-add-left"
          : "add-item";
      } else {
        return "add-item";
      }
    },
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  methods: {
    getCurrentLoggedinUserRank() {
      return store.state.auth.user.role.rank;
    },

    activateUserModal(row) {
      let confirmtext;
      if (row.isActive === true) {
        confirmtext = "Deactivate";
      } else {
        confirmtext = "Activate";
      }
      swal({
        // title: "Are you sure?",
        title: `Are you sure you want to ${confirmtext}?`,
        // text: `Are you sure you want to ${confirmtext}?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#35A2FE",
        cancelButtonColor: "#d33",
        confirmButtonText: `Yes, ${confirmtext}`,
      }).then((result) => {
        if (result.value) {
          this.activateUser(row);
        } else {
          swal.close();
        }
      });
    },
    activateUser(row) {
      let status;
      let confirmtext;
      if (row.isActive === true) {
        confirmtext = "Deactivate";
        status = false;
      } else {
        confirmtext = "Activate";
        status = true;
      }
      let test = {
        _id: row._id,
        isRootUser: row.isRootUser,
        role: row.role._id,
        firstName: row.firstName,
        lastName: row.lastName,
        isActive: status,
        email: row.email,
      };
      this.loading = true;
      return authService
        .updateUserStatus(test)
        .then((response) => {
          this.loading = false;
          row.isActive = !row.isActive;
          this.$snotify.success(
            `The ${row.firstName} has been marked ${confirmtext}.`
          );
        })
        .catch((error) => {
          this.loading = false;
          console.error("User.activateUser-error:", error);
          this.$snotify.error("Activate user failed", "Error!");
        });
      // return authService
      //     .updateUserStatus(row._id, !row.isActive)
      //     .then(response => {
      //         this.loading = false;
      //         row.isActive = !row.isActive;
      //         this.$snotify.success(`The ${row.firstName} has been marked ${confirmtext}.`);
      //     })
      //   .catch(error => {
      //       this.loading = false;
      //       console.error('User.activateUser-error:', error);
      //       this.$snotify.error('Activate user failed', 'Error!');
      //   });
    },

    action(row) {
      this.$router.push({
        name: "UserCreate",
        params: {
          _id: row._id,
        },
        props: row,
      });
    },

    // rowClick(data) { 
    //     if (store.state.auth.user.role.rank <= data.row.role.rank) {
    //         this.$router.push({
    //             name: 'UserCreate',
    //             params: {
    //                 _id: data.row._id,
    //             },
    //             props: data.row,
    //         });
    //     } else {
    //         this.$snotify.error('You can`t update this user', 'Access Denied!');
    //     }
    // },
    onLoaded() {
      this.userTable = this.$refs.userTable;
    },
    clearFilter() {
      this.custom_filter_select = "";
    },
    applyFilter(filter_val) {
      Event.$emit("vue-tables.customFilters::custom_filter", filter_val);
    },
  },
  mounted() {
    eventBus.$on("DATA_PUBLISHED", (payload) => {
      
    });
  },
};
</script>

<style>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width: 200px;
}

.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.gradientbt {
  background-image: linear-gradient(
    to right,
    rgba(38, 153, 251),
    rgba(146, 205, 255)
  );
  color: white;
}
* new css */ .toggle {
  --width: 64px;
  --height: calc(var(--width) / 3);

  position: relative;
  display: inline-block;
  width: var(--width);
  height: var(--height);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
  border-radius: var(--height);
  cursor: pointer;
  margin-bottom: 0px;
  position: relative;
  top: 2px;
}

.toggle input {
  display: none;
}

.toggle .slider {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: var(--height);
  background-color: #ccc;
  transition: all 0.4s ease-in-out;
}

.toggle .slider::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: calc(var(--height));
  height: calc(var(--height));
  border-radius: calc(var(--height) / 2);
  background-color: #fff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
  transition: all 0.4s ease-in-out;
}

.toggle input:checked + .slider {
  background-color: #35A2FE;
}

.toggle input:checked + .slider::before {
  transform: translateX(calc(var(--width) - var(--height)));
}

.toggle .labels {
  position: absolute;
  top: 3px;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 12px;
  font-family: sans-serif;
  transition: all 0.4s ease-in-out;
}

.toggle .labels::after {
  content: attr(data-off);
  position: absolute;
  right: 5px;
  color: #4d4d4d;
  opacity: 1;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
  transition: all 0.4s ease-in-out;
}

.toggle .labels::before {
  content: attr(data-on);
  position: absolute;
  left: 5px;
  color: #ffffff;
  opacity: 0;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.4);
  transition: all 0.4s ease-in-out;
}

.toggle input:checked ~ .labels::after {
  opacity: 0;
}

.toggle input:checked ~ .labels::before {
  opacity: 1;
}
.active_wrp {
  display: flex;
  align-items: center;
}

.active_wrp a {
  flex: 0 0 30%;
  color: #35A2FE;
  margin-right: 5px;
}
* new css */ .toggle {
  --width: 64px;
  --height: calc(var(--width) / 3);

  position: relative;
  display: inline-block;
  width: var(--width);
  height: var(--height);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
  border-radius: var(--height);
  cursor: pointer;
  margin-bottom: 0px;
  position: relative;
  top: 2px;
}

.toggle input {
  display: none;
}

.toggle .slider {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: var(--height);
  background-color: #ccc;
  transition: all 0.4s ease-in-out;
}

.toggle .slider::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: calc(var(--height));
  height: calc(var(--height));
  border-radius: calc(var(--height) / 2);
  background-color: #fff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
  transition: all 0.4s ease-in-out;
}

.toggle input:checked + .slider {
  background-color: #35A2FE;
}

.toggle input:checked + .slider::before {
  transform: translateX(calc(var(--width) - var(--height)));
}

.toggle .labels {
  position: absolute;
  top: 4px;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 10px;
  font-family: sans-serif;
  transition: all 0.4s ease-in-out;
}

.toggle .labels::after {
  content: attr(data-off);
  position: absolute;
  right: 5px;
  color: #4d4d4d;
  opacity: 1;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
  transition: all 0.4s ease-in-out;
}

.toggle .labels::before {
  content: attr(data-on);
  position: absolute;
  left: 5px;
  color: #ffffff;
  opacity: 0;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.4);
  transition: all 0.4s ease-in-out;
}

.toggle input:checked ~ .labels::after {
  opacity: 0;
}

.toggle input:checked ~ .labels::before {
  opacity: 1;
}

.active_wrp {
  display: flex;
  align-items: center;
}

.active_wrp a {
  flex: 0 0 30%;
  color: #35A2FE;
  margin-right: 5px;
}




@media(max-width:767px){
    .user_wrp_res .gradientbt{
        margin-bottom: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// Users.vue?2e92a542